module.exports = __webpack_public_path__ + "img/tree-01-g-leaves.87871150.png";